export const MINIMUM_LOAN_AMOUNT = 10000;
export const MAXIMUM_LOAN_AMOUNT = 1000000;

export const FieldCalculationType = {
  FIXED: "FIXED",
  PERCENTAGE: "PERCENTAGE",
};
